<template>
  <aside class="side-bar" :class="{ wide: isWide }">
    <div class="logo">
      <LogoWithTitle v-if="isWide" />
      <Logo v-else />
    </div>
    <ul class="menu-list">
      <div>
        <template v-for="(menu, index) in menus">
          <li v-if="canIAccessToThisPage(menu) && !isLastMenuItem(menu)" :key="index" class="nav-link">
            <NavMenu :menuName="menu.title" :isWide="isWide" />
          </li>
        </template>
      </div>
      <li class="nav-link">
        <NavMenu :menuName="lastMenuTitle" :isWide="isWide" class="definitions-link" />
      </li>
    </ul>
  </aside>
</template>

<script>
import MAIN_FEATURES from "@/misc/mainFeatures";
import { mapGetters } from "vuex";
import NavMenu from "./NavMenu";
import Logo from "@/assets/logos/logo.svg";
import LogoWithTitle from "@/assets/logos/logo-with-title.svg";

const NEW_BALANCE_STORE_ID = 423;

export default {
  components: {
    Logo,
    LogoWithTitle,
    NavMenu,
  },
  props: {
    isWide: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      menus: MAIN_FEATURES,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user/getUserInfo",
      currentStore: "user/getCurrentStore",
    }),
    lastMenuTitle() {
      return this.menus[this.menus.length - 1].title;
    },
  },
  methods: {
    isLastMenuItem(menuItem) {
      return menuItem.title === this.lastMenuTitle;
    },
    // todo: temporary function
    canIAccessToThisPage(menuItem) {
      if (menuItem.admin) {
        if (menuItem.name === "datalink" && this.currentStore.store_id === NEW_BALANCE_STORE_ID) {
          return true;
        }
        if (!this.userInfo.is_admin) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.side-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background-color: #1a1a1a;

  .logo {
    padding: 25px 0 10px;
    text-align: center;
    width: 100%;
  }

  .menu-list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    overflow: scroll;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
  }

  .menu-list::-webkit-scrollbar {
    width: 0 !important;
    display: none;
  }

  .definitions-link {
    margin-top: 0;
  }
}
</style>
